import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export function TableListHeaderItem(props) {
    const { columnDef: { width: columnWidth, hAlign }, item, children } = props;
    const isResponsive = Array.isArray(columnWidth);
    const width = typeof columnWidth === 'number' ? columnWidth : null;
    const [minWidth, maxWidth] = isResponsive ? columnWidth : [
        columnWidth,
        columnWidth
    ];
    const fluid = minWidth ? 1 : null;
    const justifyContent = hAlign === 'end' ? 'flex-end' : 'flex-start';
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": props.testId,
        className: item.className,
        style: _object_spread_props(_object_spread({
            display: 'flex',
            justifyContent
        }, isResponsive ? {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: minWidth,
            minWidth: 0,
            overflow: 'hidden'
        } : {
            width,
            minWidth,
            flex: fluid
        }), {
            maxWidth
        }),
        children: children || item.value
    });
}
